const DEFAULT_DOWNLOAD_FILENAME = 'download';

export const getFileNameFromDisposition = (
  contentDispositionHeader: string | undefined,
  fallbackFileName = DEFAULT_DOWNLOAD_FILENAME
) => {
  if (!contentDispositionHeader) return fallbackFileName;

  const encodedMatch = contentDispositionHeader.match(/filename\*=UTF-8''([^;]+)/i);
  if (encodedMatch?.[1]) {
    return decodeURIComponent(encodedMatch[1]);
  }

  const quotedMatch = contentDispositionHeader.match(/filename="?([^";]+)"?/i);
  return quotedMatch?.[1] ?? fallbackFileName;
};

export const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');

  anchor.setAttribute('hidden', '');
  anchor.setAttribute('href', url);
  anchor.setAttribute('download', filename);

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(url);
};
